"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResolutionsInUseManager = void 0;
const resolutions_in_use_manager_1 = require("../store/utils/resolutions-in-use-manager");
exports.ResolutionsInUseManager = resolutions_in_use_manager_1.ResolutionsInUseManager;
//# sourceMappingURL=index.js.map